import React from "react";
import { useCurrency } from "../context/CurrencyContext";

export function Price({ ghs, gbp, size = "md", className = "" }) {
  const { format } = useCurrency();
  const { main, sub } = format(ghs, gbp);
  const mainCls = { xs: "text-sm", sm: "text-base", md: "text-xl", lg: "text-3xl sm:text-4xl" }[size];
  return (
    <div className={`flex items-baseline gap-2 ${className}`} data-testid="price">
      <span className={`font-display font-semibold text-[#0D530E] ${mainCls}`}>{main}</span>
      <span className="text-[#306D29]/70 text-sm font-medium">/ {sub}</span>
    </div>
  );
}
